module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAQAAAADHm0dAAAAcElEQVR4AeXBsQpBYRgA0JPc9CeLQUnKW7BJHkBWuyxWisHgTupmkOXbPaiyX/efOcePGerIMvWwlGHuZSPDWjhqaVDYCXuNuk7CQaHG00obA6VwkdRaCGczd6HU89VWfN70NUiuQmUkw1hlIlPyT94R/xIfnFtSZQAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./~/todc-bootstrap/dist/img/checkmark.png
 ** module id = 647
 ** module chunks = 2
 **/